module.exports = __webpack_public_path__ + "img/1.1263b8eb.jpg";